import { render, staticRenderFns } from "./OutboxRelatedLetters.vue?vue&type=template&id=6c283bb4"
import script from "./OutboxRelatedLetters.vue?vue&type=script&lang=js"
export * from "./OutboxRelatedLetters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports